import { useTranslation } from 'react-i18next'
import { Heart } from 'lucide-react'

/**
 * App Footer Component
 *
 * Displays footer with branding and copyright information.
 * Used in the main app layout for authenticated pages.
 */
export const Footer = () => {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 py-6 mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-col sm:flex-row items-center justify-between w-full gap-4">
            {/* Logo and Copyright */}
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <h2 className="text-lg font-bold font-body">
                <span className="text-gray-900 dark:text-white">MyPink</span>
                <span className="text-marykay-pink">You</span>
              </h2>
              <span className="hidden sm:inline text-gray-400 dark:text-gray-600">|</span>
              <p className="text-sm">
                {t('footer.copyright', '© {{year}} MyPinkYou. All rights reserved.', {
                  year: currentYear,
                })}
              </p>
            </div>

            {/* Made with love */}
            <div className="flex items-center gap-2 text-sm">
              <span>{t('footer.madeWith', 'Made with')}</span>
              <Heart className="w-4 h-4 text-marykay-pink fill-marykay-pink" />
              <span>{t('footer.forCustomers', 'for Mary Kay customers')}</span>
            </div>
          </div>

          {/* Disclaimer */}
          <p className="text-xs text-gray-500 dark:text-gray-500 text-center max-w-2xl">
            {t(
              'landing.footer.disclaimer',
              'This application is not affiliated with Mary Kay Inc. or its subsidiaries. It is an independent tool designed solely to support the work of beauty consultants.'
            )}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
